import type { PlaceId } from '../../../shared/ids';

// 나의 위치 상태: 지금 어느 장소에 있고(null = 마을·건물 밖), 어느 자리에 앉았는지(-1 서 있음). 영상·음성 모임 규칙(2-controllers/meeting/links.ts)이 읽는다.
// 이름·친구는 옛 저장(G.save.data)에 있다. 값을 바꾸는 함수는 이 파일에만 있다(3-store).
export const ME: { room: PlaceId | null; seat: number; x: number; y: number; hand: boolean; share: boolean } = { room: null, seat: -1, x: 0, y: 0, hand: false, share: false };   // hand = 손들기, share = 화면 공유 중(영상 쪽이 아는 값을 1-endpoints가 옮겨 둔다)
export function setMyPlace(room: PlaceId | null) { ME.room = room; if (room === null) ME.seat = -1; }
export function setMySeat(seat: number) { ME.seat = seat; }
export function setMyX(x: number, y = 0) { ME.x = x; ME.y = y; }   // 가까운 사람과 이어지는 거리를 재는 데 쓴다(마을·건물은 x만, 스테이지는 y도)
export function setMyHand(on: boolean) { ME.hand = on; }
export function setMyShare(on: boolean) { ME.share = on; }
